<script>
  /**
   * FormGateway 省力化用コンポーネント
   * @see https://github.com/astanet/form-gateway
   */
  import { FORM_URL } from '../../constants.js'
  import { encrypt } from '../../modules/encrypt'

  import SubmitButton from './SubmitButton.svelte'

  export let topic
  export let message

  // Form action URL のビルド
  $: action = [
    FORM_URL,
    '/?q=',
    encodeURIComponent(encrypt(`{"topic":"projects/formgw/topics/${topic}"}`)),
    '&redirect=',
    encodeURIComponent(
      `${window.location.origin}/form-response?message=${message}`
    ),
  ].join('')

  // フォーム送信中フラグ
  let isSubmitting = false
  let form

  // 送信時
  const onSubmit = () => {
    isSubmitting = true
    // 日付をハイフン区切りではなく、スラッシュ区切りで送信
    //  一時的に日付入力要素を全てテキスト入力に切り替え、値をスラッシュ区切りに変える
    const dateInputs = form.querySelectorAll('input[type="date"]')
    dateInputs.forEach(dateInput => {
      dateInput.type = 'text'
      dateInput.value = dateInput.value.replaceAll('-', '/')
    })
    form.submit()
    //  エラーで送信できなかったりした時のため、念の為に元に戻しておく
    dateInputs.forEach(dateInput => {
      dateInput.value = dateInput.value.replaceAll('/', '-')
      dateInput.type = 'date'
    })
  }
</script>

<div class="container columns is-centered">
  <div
    class="column is-half-tablet is-half-desktop is-one-third-widescreen is-one-third-fullhd"
  >
    <form
      bind:this={form}
      {action}
      method="POST"
      on:submit|preventDefault={onSubmit}
    >
      <slot />

      <div class="block">
        <SubmitButton {isSubmitting}>送信</SubmitButton>
      </div>
    </form>
  </div>
</div>
